import { Octopus } from '@maximizer/core/shared/domain';
import { Mapper } from '../../../mappers';
import { WidgetItem, WidgetLayout } from '../../../models';
import { WidgetLayout as OctopusWidgetLayout } from '../models';

export class WidgetLayoutMapper extends Mapper<
  OctopusWidgetLayout,
  WidgetLayout
> {
  from(source: OctopusWidgetLayout): WidgetLayout {
    return {
      key: source?.Key ?? null,
      name: source?.Name ?? '',
      entityType: source?.EntityType ?? Octopus.EntityType.Unknown,
      widgetItems: this.mapWidgets(source?.Widgets) || [],
    };
  }

  mapWidgets(widgets: string): WidgetItem[] {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(widgets, 'text/xml');
    const widgetsXML = xmlDoc.getElementsByTagName('WidgetLayout');
    const data =
      widgetsXML.length > 0
        ? widgetsXML[0].getElementsByTagName('Data')[0]?.textContent
        : null;
    const widgetItems: WidgetItem[] = data ? JSON.parse(data) : [];

    return widgetItems;
  }
}
